import { createFileRoute } from '@tanstack/react-router'
import { SupplierRefundDetailPage } from '../../../../features/purchasing/refund-pages'
import { documentActionSearchSchema } from '../../../../features/sales/document-action'

export const Route = createFileRoute('/_app/supplier-refunds/$refundId/')({
  validateSearch: documentActionSearchSchema,
  component: SupplierRefundDetailPage,
})
